var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-fixed tw-w-screen tw-h-screen tw-bg-black tw-bg-opacity-50 tw-z-100 tw-flex tw-justify-center md:tw-justify-end"},[_c(_setup.MainNavbarUserCard)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }